import React from "react";
import headerFootball from "@/assets/images/livescore/football-header.svg";
import iconGolfOutline from "@/assets/images/livescore/icon-golf-outline.svg";

const LiveScoreHeader = () => {
  const tdBdrB =
    "border-b border-t-0 border-solid border-[color:var(--theme-border)]";
  const rowH = "h-[46px] align-middle text-xs text-dark-charcoal";

  return (
    <thead className="hidden md:!table-header-group">
      <tr
        className={`kbv-cs-bg-header-bar ${rowH}`}
      >
        <td className="w-[34px] min-w-[34px] p-px text-center">
          <img src={headerFootball} alt="" className="mx-auto block h-[14px] w-[14px] object-contain" />
        </td>
        <td colSpan={6} className="px-2 py-px text-left">
          <div className="flex h-full items-center">
            <span className="uppercase">Tất cả trận đang live</span>
          </div>
        </td>
        <td colSpan={3} className="py-px text-center font-bold">
          <span>HDP</span>
        </td>
        <td colSpan={3} className="py-px text-center font-bold">
          <span>Tài xỉu</span>
        </td>
        <td colSpan={1} className="p-px" />
      </tr>

      <tr className={`bg-white min-h-[46px] ${rowH}`}>
        <td className={`w-[32px] min-w-[32px] border-l-0 p-px ${tdBdrB}`}>
          <span className="inline-block" aria-hidden />
        </td>
        <td className={`min-w-[80px] p-px py-1 ${tdBdrB}`}>Thời gian</td>
        <td className={`w-[50px] min-w-[50px] p-px py-1 ${tdBdrB}`} />
        <td className={`min-w-0 p-px px-1 ${tdBdrB}`}>Đội nhà</td>
        <td className={`w-[70px] min-w-[70px] p-px ${tdBdrB}`}>Tỉ số</td>
        <td className={`w-[33px] min-w-[33px] whitespace-nowrap p-px ${tdBdrB}`}>
          <img src={iconGolfOutline} alt="" className="mx-auto h-[11px] w-[11px] opacity-70 object-contain" />
        </td>
        <td className={`min-w-0 p-px px-1 ${tdBdrB}`}>Đội khách</td>
        <td className={`w-[50px] min-w-[50px] p-px ${tdBdrB}`}>Chủ</td>
        <td className={`w-[50px] min-w-[50px] p-px ${tdBdrB}`}>Tỷ lệ</td>
        <td className={`w-[50px] min-w-[50px] p-px ${tdBdrB}`}>
          <span>Khách</span>
        </td>
        <td className={`w-[50px] min-w-[50px] p-px ${tdBdrB}`}>Chủ</td>
        <td className={`w-[50px] min-w-[50px] p-px ${tdBdrB}`}>Tỷ lệ</td>
        <td className={`w-[50px] min-w-[50px] border-r-0 p-px ${tdBdrB}`}>
          <span>Khách</span>
        </td>
      </tr>
    </thead>
  );
};

export default LiveScoreHeader;
